import 'styles/account/shared/flash-messages.scss';

import classNames from 'classnames';
import React from 'react';

import propTypes from 'propTypes';

const FlashMessages = ({ flashMessages, makeClearForId }) => (
  <div className="FlashMessages">
    {flashMessages.map((flashMessage, index) => (
      <FlashMessage
        key={index}
        flashMessage={flashMessage}
        onClear={makeClearForId(flashMessage.id)}
      />
    ))}
  </div>
);

FlashMessages.propTypes = {
  flashMessages: propTypes.arrayOf(propTypes.FlashMessage).isRequired,
  makeClearForId: propTypes.func.isRequired,
};

export const FLASH_MESSAGE_TIMEOUT = 5000;
export const FLASH_SUCCESS = 'FlashMessage--success';
export const FLASH_ERROR = 'FlashMessage--error';

class FlashMessage extends React.Component {
  static propTypes = {
    flashMessage: propTypes.FlashMessage.isRequired,
    onClear: propTypes.func.isRequired,
  };

  componentDidMount() {
    window.setTimeout(() => {
      this.props.onClear();
    }, FLASH_MESSAGE_TIMEOUT);
  }

  render() {
    const { className, message } = this.props.flashMessage;
    return (
      <div className={classNames('FlashMessage', className)}>{message}</div>
    );
  }
}

export default FlashMessages;



// WEBPACK FOOTER //
// ./app/javascript/apps/account/components/shared/FlashMessages.js